import { LayoutPanelTop } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { WebsiteWithImages } from "@/types/prisma";
import type { ServiceArea } from "@prisma/client";

const serviceAreaFreeFormSection = {
  type: SECTION_TYPES.SERVICE_AREA_FREE_FORM,
  content: {
    header: "Service area info",
    freeform: "",
  },
  meta: {
    displayName: "Service area freeform content section",
    displayDescription: "Introduce your service area to your customers.",
    displayIcon: LayoutPanelTop,
  },
  aiPrompt(serviceArea: ServiceArea, website: WebsiteWithImages, serviceList: string[]) {
    return `In this section, use the flexibility of the unstyled HTML format to create engaging and visually appealing content. 
    Use headings (h2 or h3 tags), paragraphs, and lists to structure the content in a way that is easy to read and understand for the audience. 
    Assume that there is already an H2 on the page leading into this section, so DO NOT LEAD WITH A HEADING.

    Here is an exmaple of what you could write about, but please use your own creativity!!

    Header: something like "We've got ${serviceArea.city} covered" but more creative. Write like a human.

    Write a paragraph or two about what ${serviceArea.name} is known for.

    H3: Comprehensive ${website?.industry} Solutions
    Talk about how we offer a wide range of ${website.industry} solutions tailored to meet the needs of ${serviceArea.name}. Mention some from our list: ${serviceList} in an HTML UL (unordered list).

    H3: Why Choose Us for ${website?.industry} in ${serviceArea.city}
    Discuss how our expert team is equipped to handle all the requirements with professionalism and efficiency.
    and how we are a trusted name. We understand the unique needs of the local community and are committed to providing exceptional service. See our reviews, etc.

    H3: Serving All Neighborhoods in ${serviceArea.city}
    We proudly serve all areas of ${serviceArea.name}, including [mention specific neighborhoods here if you can think of any]. No matter where you are in ${serviceArea.name}, our team is ready to assist you with all your needs.`;
  },
};

export default serviceAreaFreeFormSection;
